var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.breadcrumbs},_vm._l((_vm.breadcrumbs),function(titleToken,to,i){return _c('span',{key:to},[(i > 0)?_c('app-icon',{attrs:{"name":"chevron-right"}}):_vm._e(),_vm._v(" "),_c('nuxt-link',{attrs:{"to":_vm.localePath(to)}},[_vm._v(" "+_vm._s(_vm.getTitle(titleToken))+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }